import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import { apiPath } from "../../utility/Constant";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import CustomEditor from "../../components/shared/customEditor/CustomEditor";

const EditJobs = () => {
  const { jobsApi } = apiPath;
  const { id } = useParams();
  const [jobData, jobsListLoading] = useFetch(`${jobsApi}/${id}`, true);
  console.log("this is id", jobData);
  const [submitButtonDisable, setSubmitButtonDisable] = useState(false);
  if (jobsListLoading) {
    return <Loading />;
  }
  const labelFieldCss = `label`;
  const inputFieldCss = `input input-bordered w-full z-0`;
  const inputContainerDiv = `mb-4 relative over`;

  const handleFormSubmit = async (values) => {
    try {
      setSubmitButtonDisable(true);
      const data = values;
      console.log("this is form data", values);
      console.log("this is data", data);
      updateData(`${jobsApi}/${id}`, data, true, null, null, false);
    } catch (error) {
      console.error("Error while submitting form:", error);
    }
  };
  const update = (data) => {
    console.log(data);
    const newData = { description: data };
    updateData(`${jobsApi}/${id}`, newData, true, null, null, false);
  };
  return (
    <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
      <Formik
        initialValues={{
          title: jobData.title || "",
          queryTitle: jobData.queryTitle || "",
          exp: jobData.exp || "",
          live: jobData.live || "",
        }}
        onSubmit={handleFormSubmit}
        render={({ values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 gap-5 overflow-hidden pt-5">
              <div className={`${inputContainerDiv} col-span-2 md:col-span-1`}>
                <label htmlFor="title" className="label">
                  <span>
                    Job Title{" "}
                    <span className="text-red-500 text-md font-semibold">
                      &nbsp;*
                    </span>
                  </span>
                </label>
                <Field
                  placeholder="Job Title"
                  id="title"
                  name="title"
                  type="text"
                  autoComplete="text"
                  required
                  className={inputFieldCss}
                />
              </div>

              <div className={`${inputContainerDiv} col-span-2`}>
                <label htmlFor="queryTitle" className={labelFieldCss}>
                  Slug title
                </label>
                <Field
                  placeholder="queryTitle"
                  id="queryTitle"
                  name="queryTitle"
                  type="text"
                  autoComplete="text"
                  className={inputFieldCss}
                />
              </div>
              <div className={`${inputContainerDiv} col-span-2`}>
                <label htmlFor="discount" className={labelFieldCss}>
                  Experience
                </label>
                <Field
                  placeholder="experience"
                  id="exp"
                  name="exp"
                  type="text"
                  autoComplete="text"
                  className={inputFieldCss}
                />
              </div>
              <div className={`${inputContainerDiv} col-span-2 md:col-span-1`}>
                <label htmlFor="live" className={labelFieldCss}>
                  <span>
                    Job Status {jobData.live}
                    <span className="text-red-500 text-md font-semibold">
                      {" "}
                      &nbsp;*
                    </span>
                  </span>
                </label>
                <Field
                  as="select"
                  id="live"
                  name="live"
                  className={inputFieldCss}
                  required
                >
                  <option value="none">Select An Option</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </Field>
              </div>
            </div>
            <div className="mt-16 mx-auto flex justify-center">
              <button type="submit" className="btn btnW7ide hover:bg-gray-100">
                Submit
              </button>
            </div>
          </Form>
        )}
      />

      <div>
        <br /> <br />
        <h1 className="py-5 ">Description Section</h1>
        <br />
        <CustomEditor oldData={jobData.description} saveDataHandler={update} />
      </div>
    </div>
  );
};

export default EditJobs;
